
import React, { useEffect, useState, useContext, Fragment } from 'react';
import { isNumeric, isMonthAndYearEmpty, getStatusFlagValue, getButtonDisabledStates } from '../Custom/Custom'
import messages from '../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading'


function PriceAgricultureParityFormMiscellaneousDataAndMiscellaneousData({
  config,
  resetFormData,
  userInfoObject,
  yearName,
  priceAgrilcultureData,
  url,
  agricultureCode,
  type,
  storedLanguage,
  othersData
}) {

  

  const navigate = useNavigate();
  const [itemData, setItemData] = useState({});
 

  let headQuarterRemark = [
    'Price is Too Low.',
    'Price is too High.',
    'Price does not match with unit.',
    'Price does not match with variety.',
    'Others.'
  ]
  let otherRemark = [
    'Production is low',
    'Production is high',
    'Less supply',
    'High supply',
    'Not Available.',
    'On sale.',
    'Seasonal effect',
    'Discounted Item',
    'Other.',
  ]

  // Table Header
  const renderHeader = (i) => (
    <thead key={`thead-${i}`}>
      <tr>
        {type === 'PriceAgricultureParityFormMiscellaneous' ? (
            <>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.SERIAL_NO : othersData.en.SERIAL_NO}</th>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.ITEM_NAME : othersData.en.ITEM_NAME}</th>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.PREVIOUS_YEAR_AREA : othersData.en.PREVIOUS_YEAR_AREA}</th>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.CURRENT_YEAR_AREA : othersData.en.CURRENT_YEAR_AREA}</th>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.REMARKS : othersData.en.REMARKS}</th>
            </>
          ) : (
            <>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.SERIAL_NO : othersData.en.SERIAL_NO}</th>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.CATEGORY : othersData.en.CATEGORY}</th>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.UNIT_SOLD : othersData.en.UNIT_SOLD}</th>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.REVENUE_FIXATION : othersData.en.REVENUE_FIXATION}</th>
              <th className="text-center">{storedLanguage === 'hi' ? othersData.hi.REMARKS : othersData.en.REMARKS}</th>
            </>
          )}
        

      </tr>
    </thead>
  );


  //handle  onChange
  const handleOnChange = (itemCode, field, newValue) => {

  if (!isNumeric(newValue)) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = '';
    }

   setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [itemCode]: {
          ...prevItemData[itemCode],
          [field]: newValue,
        
        }
      };

      return updatedItemData;
    });


  };

  //handle variation calculation
  const handleValidateItemVariationPrice = (itemCode, styleField, remarkRequiredField, newValue, average, variation) => {



    let dynamicStylesForTextBox = {}
    let isRequiredRemark = false

    if (newValue !== 0) {
      let dif = average * variation / 100;
      if (variation === 0 || dif === 0) {
        return;
      }
      if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
        toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
        dynamicStylesForTextBox = {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        newValue = dynamicStylesForTextBox
        if (itemData[itemCode].remark === 'NQ' || itemData[itemCode].remark === '') {
          isRequiredRemark = true
        }


      } else {

        dynamicStylesForTextBox = {
          borderColor: '#dcdfe1',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        isRequiredRemark = false
        newValue = dynamicStylesForTextBox


      }
    }


    
    setItemData(prevItemData => ({
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [styleField]: newValue,
        [remarkRequiredField]: isRequiredRemark
      }
    }));

  }


  useEffect(() => {
    const initialData = {};

    priceAgrilcultureData.forEach(item => {
      initialData[item.itemTitleCode] = {
        itemTitleType: item.itemTitleType,
        itemTitleCode: item.itemTitleCode, //unique
        itemTitleName: item.itemTitleName,
        revisedYearPrice: item.revisedYearPrice,
        realYearPrice: item.realYearPrice,
        remark: item.remark,
        statusFlag: item.statusFlag,
        remarkSelectValue:item.remark,

        style: {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 3px'
        },
        revisedYearPriceIsRequiredRemark: false,
        realYearPriceIsRequiredRemark: false,
      

      };

    });
   
    setItemData(initialData);
  }, [priceAgrilcultureData]);


  const remarkDropDown = (item, i, selectedValueKey, forRemarkTextKey) => {

    let headQuarterSelected = '';
    let otherSelected = '';
    
    if(typeof item==='undefined'){
      return false
    } 

    if (headQuarterRemark.includes(item[forRemarkTextKey])) {
      headQuarterSelected = item[forRemarkTextKey]
    }
    if (otherRemark.includes(item[forRemarkTextKey])) {
      otherSelected = item[forRemarkTextKey]
    }
  
    return (
      <>

        {
          (userInfoObject.userLevel !== 'HEAD QUARTER') &&
          (!otherRemark.includes(item[forRemarkTextKey])) && item[forRemarkTextKey] &&
          <label className="text-danger danger_msg_fontSize">{item[forRemarkTextKey]}</label>
        }
        {
          (userInfoObject.userLevel === 'HEAD QUARTER') &&
          (!headQuarterRemark.includes(item[forRemarkTextKey])) && item[forRemarkTextKey] &&
          <label className="text-danger danger_msg_fontSize">{item[forRemarkTextKey]}</label>
        }


        {userInfoObject.userLevel === 'HEAD QUARTER' ?
          <select
            key={`thead-${i}`}
            className="form-select"
            name={`${selectedValueKey}${i}`}
            id={`${selectedValueKey}${i}`}
            value={headQuarterSelected ? headQuarterSelected : item[selectedValueKey]}
            onChange={e => handleOnChangeRemark(item, selectedValueKey, forRemarkTextKey, e.target.value)}
          >
            <option value="">[--Select--]</option>
            {headQuarterRemark.map((remarkItem, i) => {
              return (
                <option value={remarkItem} key={i}>{remarkItem}</option>

              )
            })}
          </select>

          :
          <select
            key={`thead-${i}`}
            className="form-select"
            name={`${selectedValueKey}${i}`}
            id={`${selectedValueKey}${i}`}
            value={otherSelected ? otherSelected : item[selectedValueKey]}
            onChange={e => handleOnChangeRemark(item, selectedValueKey, forRemarkTextKey, e.target.value)}
          >

            <option value="">[--Select--]</option>
            {otherRemark.map((remarkItem, i) => {
              return (
                <option value={remarkItem} key={i}>{remarkItem}</option>

              )
            })}

          </select>

        }

      </>
    );
  };

  const handleOnChangeRemark = (item, field, forRemarkTextKey, newValue) => { //Remark on change
 
    let isRequiredRemark = false;
    if (field === 'remark' &&  (item.revisedYearPriceIsRequiredRemark === false || 
      item.realYearPriceIsRequiredRemark === false)
      && newValue === '' && item.remark === '') {
      isRequiredRemark = true
    }


    let indexId = item.itemTitleCode

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [indexId]: {
          ...prevItemData[indexId],
          [field]: newValue,
          [forRemarkTextKey]: '',
          'revisedYearPriceIsRequiredRemark': isRequiredRemark,
          'realYearPriceIsRequiredRemark': isRequiredRemark
        }
      };
      return updatedItemData;
    });

  }


  const handleSavePriceAgricultureParityFormMiscellaneousData = async (e, buttonType) => {

     if(yearName===''){
      toast.error('Please Select Year.', messages.COLOR_RED);
      return false;
     }

    if(type==='PriceAgricultureParityFormMiscellaneous' && agricultureCode==='03'){
      if(!validateFormMis()){
        return false;
      }
    }

    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel); //button click status flag
    const customItemCodes = [];
    let check = 0;
    let localbodyCodeCheck = 0
    let statusFlag = '';


  

    for (let id in itemData) {
    
      let realYearPrice = itemData[id].realYearPrice || 0;
      let revisedYearPrice = itemData[id].revisedYearPrice || 0;
      let itemTitleCode = itemData[id].itemTitleCode;
      // let statusFlag = itemData[id].statusFlag;
      let remark = itemData[id].remarkSelectValue;
      let itemTitleName=itemData[id].itemTitleName
      let itemTitleType=itemData[id].itemTitleType
      let revisedYearPriceIsRequiredRemark = itemData[id].revisedYearPriceIsRequiredRemark;
      let realYearPriceIsRequiredRemark = itemData[id].realYearPriceIsRequiredRemark;
  


      if ((revisedYearPriceIsRequiredRemark || realYearPriceIsRequiredRemark)  && remark === '') {
        toast.error(messages.REMARK_MSG, messages.COLOR_RED);
        return false;
      }

      if (remark === '' || remark == null) {
        remark = '';
      }
      const customObject = {
         realYearPrice: realYearPrice,
        revisedYearPrice: revisedYearPrice,
        itemTitleCode: itemTitleCode,
        itemTitleName:itemTitleName,
        itemTitleType:itemTitleType,
        statusFlag: clickButtonStatusFlag,
        remark:remark

      };
      customItemCodes.push(customObject);

    }
    let postData = {
      itemCodes: customItemCodes,
      payload: {
        CurrentYear: yearName,
        PreviousYear:yearName-1,
        itemTypeCode: agricultureCode,
        buttonType: buttonType,
        statusButtonFlag: clickButtonStatusFlag
       
        
      }
    };


 

  // return false; 
    showLoading(true)
    try {

      const response = await axios.post(`${API_URL}api/otherPrices/${url}`, postData, config);
      if (response.data.status) {
        toast.success(response.data.message, messages.COLOR_RED);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showLoading(false);
      resetForm()

    }

  }



  const validateFormMis = () => {
      let msg = "";

      let variety0 = parseInt(itemData['01'].revisedYearPrice || 0);
      let unit0 = parseInt(itemData['01'].realYearPrice || 0);

      
      let variety= 0;
      let unit= 0;
      let varietyTotal = 0;
      let unitTotal= 0;

      let keys = Object.keys(itemData);

      for (let i = 1; i < keys.length; i++) {
        let id = keys[i];
        variety = itemData[id].realYearPrice || 0;
        varietyTotal = varietyTotal + parseInt(variety)

        unit = itemData[id].revisedYearPrice || 0;
        unitTotal = unitTotal + parseInt(unit)

      }
      if(variety0 !== varietyTotal){
        msg += "\n Previous Year Area Item 1 = Item (2+3+4+5+6+7)";
        validationColor('01','revisedYearPriceStyle');
      }
      if(unit0 !== unitTotal){
        msg += "\n Current Year Area Item 1 = Item (2+3+4+5+6+7)";
        validationColor('01','realYearPriceStyle');
      }


      if(msg!==""){
        alert(msg);
        return false;
      }

    }
    
    
 

  const validationColor=(itemCode,styleField)=>{
   let  dynamicStylesForTextBox = {
      borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
      borderStyle: 'solid',
      borderWidth: '1px 1px 1px 6px'
    }
    let newValue = dynamicStylesForTextBox

    setItemData(prevItemData => ({
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [styleField]: newValue,
       
      }
    }));

  }

  const resetForm = () => {
    resetFormData()
  }


  return (
    <>
      {/* <ToastContainer /> */}
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered">
            {renderHeader(0)}
            <tbody>
              {priceAgrilcultureData && priceAgrilcultureData.map((item, i) => {

                return (
                  <tr key={i}>
                    <td>
                      {++i}
                    </td>

                    <td>
                      <input
                        type='text'
                        className="form-control"
                        name={`itemTitleName${i}`}
                        id={`itemTitleName${i}`}
                        value={itemData[item.itemTitleCode]?.itemTitleName}
                        disabled
                      />

                    </td>

                    <td>
                      <input
                        type='text'
                        className="form-control"
                        style={itemData[item.itemTitleCode]?.revisedYearPriceStyle || {}}
                        name={`revisedYearPrice${i}`}
                        id={`revisedYearPrice${i}`}
                        maxLength="12"
                        value={itemData[item.itemTitleCode]?.revisedYearPrice}
                        onChange={e => handleOnChange(item.itemTitleCode, 'revisedYearPrice', e.target.value)}
                        onBlur={e => handleValidateItemVariationPrice(item.itemTitleCode, 'revisedYearPriceStyle', 'revisedYearPriceIsRequiredRemark', parseFloat(e.target.value), item.avgRevisedYearPrice, item.variance)}
                      />
                    </td>

                    <td>
                      <input
                        type='text'
                        className="form-control"
                        name={`realYearPrice${i}`}
                        id={`realYearPrice${i}`}
                        maxLength="12"
                        style={itemData[item.itemTitleCode]?.realYearPriceStyle || {}}
                        value={itemData[item.itemTitleCode]?.realYearPrice}
                        onChange={e => handleOnChange(item.itemTitleCode, 'realYearPrice', e.target.value)}
                        onBlur={e => handleValidateItemVariationPrice(item.itemTitleCode, 'realYearPriceStyle', 'realYearPriceIsRequiredRemark', parseFloat(e.target.value), item.avgRealYearPrice, item.variance)}
                      />
                    </td>

                    <td>
                      {remarkDropDown(itemData[item?.itemTitleCode], i, 'remarkSelectValue', 'remark')}
                    </td>

                  </tr>
                )
              })

              }

            </tbody>
          </table>
        </div>

        <div className="row">
          <div className="col-12 text-center pt-3">
         
              <button
                onClick={(e) => handleSavePriceAgricultureParityFormMiscellaneousData(e, 'SAVE')}
                type="button"
                className="btn btn_orange mx-1"
              >Save
              </button>
          

              <button
                onClick={(e) => handleSavePriceAgricultureParityFormMiscellaneousData(e, 'SUBMIT')}
                type="submit"
                className="btn btn_orange mx-1"
              >Submit
              </button>


            <button
              type="reset"
              className="btn btn_orange mx-1"
              onClick={resetForm}
            >
              Reset
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={(e) => (navigate("/dashboard"))}
            >
              Cancel
            </button>
          </div>
        </div>

      </div>
    </>
  )
}

export default PriceAgricultureParityFormMiscellaneousDataAndMiscellaneousData